"use client"; // Important for Next.js client-side code

import { useRouter } from "next/navigation";
import { useCallback, useEffect, useTransition } from "react";

// Create an observer to track route changes
const createRouteObserver = () => {
  let observer = null;

  const setObserver = (callback) => {
    observer = callback;
  };

  const notify = () => {
    if (observer) {
      observer();
    }
  };

  return { setObserver, notify };
};

const routeObserver = createRouteObserver();

// Custom hook for async route push
export const useAsyncRoutePush = () => {
  const [isPending, startTransition] = useTransition();
  const router = useRouter();

  const asyncPush = useCallback(
    async (path) =>
      new Promise((resolve) => {
      startTransition(() => {
        router.push(path);
      });

      routeObserver.setObserver(() => {
        resolve();
      });
      }),
    [router, startTransition]
  );

  useEffect(() => {
    if (!isPending) {
      routeObserver.notify();
    }
  }, [isPending]);

  return asyncPush;
};
